"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountSpringboardEngagementMenu = void 0;
var react_1 = __importStar(require("react"));
var clerk_react_1 = require("@clerk/clerk-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var Telemetry_1 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var classnames_1 = __importDefault(require("classnames"));
var pageSavedStatus_1 = require("./pageSavedStatus");
var react_transition_group_1 = require("react-transition-group");
var AuthenticationContext_1 = require("Public/Identity/AuthenticationContext");
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var UserAvatar_1 = require("@CommonFrontend/Public/Springboard/UserAvatar");
var AuthenticationProvider_1 = __importStar(require("Public/Identity/AuthenticationProvider"));
var track = function (name, params) {
    Telemetry_1.Telemetry.getInstance().track(name, params);
};
var c = (0, BemBuilder_1.default)("springboard-engagement-menu");
var aboutQwilrUrl = "https://qwilr.com?utm_source=public_page&utm_medium=product_menu&utm_campaign=about_qwilr";
var DEFAULT_PERSIST_TIME = 5000;
var STORAGE_KEY = "shouldSavePage";
var PopoverMenuItem = function (_a) {
    var label = _a.label, icon = _a.icon, buttonProps = __rest(_a, ["label", "icon"]);
    return (react_1.default.createElement(kaleidoscope_1.Button, __assign({}, buttonProps, { type: kaleidoscope_1.ButtonType.Tertiary, className: c("menu-button") }),
        react_1.default.createElement("div", { className: c("menu-button-icon") }, icon),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "left", className: c("button-text-override") }, label)));
};
var LoggedInMenu = function (_a) {
    var mailto = _a.mailto;
    var authAppBaseUrl = (0, AuthenticationContext_1.useAuthenticationContext)().authAppBaseUrl;
    var springboardBaseUrl = (0, inversify_react_1.useInjection)("springboardAppBaseUrl");
    var signOut = (0, clerk_react_1.useAuth)().signOut;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        mailto && (react_1.default.createElement(PopoverMenuItem, { label: "Contact page owner", href: function () { return "mailto:".concat(mailto); }, onClick: function () { return track("Clicked Contact Page Owner", { event_origin: "springboard engagement menu" }); }, icon: react_1.default.createElement(icons_1.Mail, null) })),
        react_1.default.createElement(PopoverMenuItem, { label: "Saved pages", href: function () { return "".concat(springboardBaseUrl, "/saved?origin=springboard%20engagement%20menu"); }, icon: react_1.default.createElement(icons_1.Bookmark, null) }),
        react_1.default.createElement(PopoverMenuItem, { label: "Profile", href: function () { return "".concat(authAppBaseUrl, "/user/profile?origin=springboard%20engagement%20menu"); }, icon: react_1.default.createElement(icons_1.User, null) }),
        react_1.default.createElement(PopoverMenuItem, { label: "About Qwilr", href: function () { return aboutQwilrUrl; }, onClick: function () { return track("Clicked About Qwilr", { is_auth: true }); }, icon: react_1.default.createElement(icons_1.InformationCircle, null) }),
        react_1.default.createElement(PopoverMenuItem, { label: "Log out", onClick: function () { return signOut(); }, icon: react_1.default.createElement(icons_1.Logout, null) })));
};
var LoggedOutMenu = function (_a) {
    var onClickContactPageOwner = _a.onClickContactPageOwner, contactOwnerEnabled = _a.contactOwnerEnabled;
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    var continueUrl = window.location.href;
    var loginUrl = getAuthUrl("login", continueUrl, AuthenticationContext_1.AuthenticationOrigin.SpringboardEngagementMenu);
    var signupUrl = getAuthUrl("signup", continueUrl, AuthenticationContext_1.AuthenticationOrigin.SpringboardEngagementMenu);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        contactOwnerEnabled && (react_1.default.createElement(PopoverMenuItem, { label: "Contact page owner", onClick: onClickContactPageOwner, icon: react_1.default.createElement(icons_1.Mail, null) })),
        react_1.default.createElement(PopoverMenuItem, { label: "Sign up", openInSameTab: true, href: function () { return signupUrl; }, onClick: function () { return track("Clicked Springboard Menu Consumer Signup"); }, icon: react_1.default.createElement(icons_1.User, null) }),
        react_1.default.createElement(PopoverMenuItem, { label: "Log in", openInSameTab: true, href: function () { return loginUrl; }, onClick: function () { return track("Clicked Springboard Menu Consumer Login"); }, icon: react_1.default.createElement(icons_1.Login, null) }),
        react_1.default.createElement(PopoverMenuItem, { label: "About Qwilr", href: function () { return aboutQwilrUrl; }, onClick: function () { return track("Clicked About Qwilr", { is_auth: false }); }, icon: react_1.default.createElement(icons_1.InformationCircle, null) })));
};
var WithLoadingState = function (_a) {
    var loading = _a.loading, className = _a.className, children = _a.children;
    if (loading) {
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement(kaleidoscope_1.GhostBlock, null)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
var MaybeWithPanel = function (_a) {
    var isInline = _a.isInline, children = _a.children;
    if (isInline) {
        return react_1.default.createElement("div", { className: c("inline-navigation") }, children);
    }
    return (react_1.default.createElement(kaleidoscope_1.Panel, { className: c(), elevation: 2 }, children));
};
var SpringboardAccountPrompt = function (_a) {
    var continueUrl = _a.continueUrl, action = _a.action;
    var createAccountPopoverClassname = "create-account-popover";
    var origin;
    if (action === "contact owner") {
        origin = AuthenticationContext_1.AuthenticationOrigin.SpringboardEngagementContactOwner;
    }
    else {
        origin = AuthenticationContext_1.AuthenticationOrigin.SpringboardEngagementSavePage;
    }
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    var loginUrl = getAuthUrl("login", continueUrl, origin);
    var signupUrl = getAuthUrl("signup", continueUrl, origin);
    var heading = action === "save page"
        ? "Create a free Qwilr Springboard account to save your pages all in one place"
        : "Verify your identity to contact the page owner";
    (0, react_1.useEffect)(function () {
        track("Saw Consumer Signup Modal", { origin: action });
    }, []);
    return (react_1.default.createElement("div", { className: c(createAccountPopoverClassname) },
        react_1.default.createElement(kaleidoscope_1.RainbowBar, { size: "small" }),
        react_1.default.createElement("img", { className: c("".concat(createAccountPopoverClassname, "-image")), src: "/Public/Assets/Images/springboard-signup.jpg" }),
        react_1.default.createElement("div", { className: c("".concat(createAccountPopoverClassname, "-content")) },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "4", align: "center" }, heading),
            react_1.default.createElement(kaleidoscope_1.Button, { className: c(createAccountPopoverClassname), href: function () { return signupUrl; }, onClick: function () { return localStorage.setItem(STORAGE_KEY, "true"); } },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: c("".concat(createAccountPopoverClassname, "-button-text")) }, "Create account")),
            react_1.default.createElement(kaleidoscope_1.Text, null,
                "Already have an account? ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: loginUrl }, "Log in")))));
};
var SaveButtonWithSpringboardAccountPopover = function (_a) {
    var button = _a.button;
    var continueUrl = new URL(window.location.href);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { className: (0, classnames_1.default)(c("popover"), c("create-account-popover-container")), size: kaleidoscope_1.PopoverSize.Large, button: function (buttonProps) {
            return button(buttonProps);
        } },
        react_1.default.createElement(SpringboardAccountPrompt, { continueUrl: continueUrl, action: "save page" })));
};
var UnsavePrompt = function (_a) {
    var handleDelete = _a.handleDelete;
    var springboardBaseUrl = (0, inversify_react_1.useInjection)("springboardAppBaseUrl");
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("unsave-popover")) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("unsave-popover-icon")) },
            react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Medium })),
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, "Page saved to Qwilr Springboard"),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("unsave-popover-actions")) },
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: handleDelete, type: kaleidoscope_1.ButtonType.Secondary, className: c("button-text-override"), width: "full" }, "Unsave"),
            react_1.default.createElement(kaleidoscope_1.Button, { openInSameTab: true, href: function () { return "".concat(springboardBaseUrl, "/saved?origin=saved%20page%20button"); }, className: c("button-text-override"), width: "full" }, "Go to saved pages"))));
};
var InlineSaveButton = function (_a) {
    var handleSave = _a.handleSave, handleDelete = _a.handleDelete, handleShowUnsavePrompt = _a.handleShowUnsavePrompt, saved = _a.saved, pending = _a.pending;
    if (saved) {
        return (react_1.default.createElement(kaleidoscope_1.Popover, { className: c("popover"), size: kaleidoscope_1.PopoverSize.Medium, offset: 16, recalculatePositionOnResize: true, onChange: function (open) {
                if (open) {
                    handleShowUnsavePrompt();
                }
            }, button: function (props) { return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Unsave page" },
                react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, props, { buttonState: pending ? kaleidoscope_2.ButtonState.Waiting : kaleidoscope_2.ButtonState.Idle, disabled: pending, className: c("inline-save-button"), type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.BookmarkFilled, null) })))); } },
            react_1.default.createElement(UnsavePrompt, { handleDelete: handleDelete })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Save page" },
            react_1.default.createElement(kaleidoscope_1.IconButton, { buttonState: pending ? kaleidoscope_2.ButtonState.Waiting : kaleidoscope_2.ButtonState.Idle, disabled: pending, className: c("inline-save-button"), onClick: handleSave, type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.Bookmark, null) }))));
};
var SaveButton = function (_a) {
    var handleSave = _a.handleSave, handleDelete = _a.handleDelete, handleShowUnsavePrompt = _a.handleShowUnsavePrompt, saved = _a.saved, pending = _a.pending;
    if (saved) {
        return (react_1.default.createElement(kaleidoscope_1.Popover, { className: c("popover"), size: kaleidoscope_1.PopoverSize.Medium, offset: 8, recalculatePositionOnResize: true, onChange: function (open) {
                if (open) {
                    handleShowUnsavePrompt();
                }
            }, button: function (props) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ buttonState: pending ? kaleidoscope_2.ButtonState.Waiting : kaleidoscope_2.ButtonState.Idle, disabled: pending, type: kaleidoscope_1.ButtonType.Tertiary, className: c("save-button") }, props),
                react_1.default.createElement(icons_1.BookmarkFilled, null),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("button-text-override") }, "Saved"))); } },
            react_1.default.createElement(UnsavePrompt, { handleDelete: handleDelete })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.Button, { buttonState: pending ? kaleidoscope_2.ButtonState.Waiting : kaleidoscope_2.ButtonState.Idle, disabled: pending, onClick: handleSave, type: kaleidoscope_1.ButtonType.Tertiary, className: c("save-button") },
            react_1.default.createElement(icons_1.Bookmark, null),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("button-text-override") }, "Save"))));
};
var NotificationMessage;
(function (NotificationMessage) {
    NotificationMessage["SaveSuccessful"] = "Page saved";
    NotificationMessage["UnsaveSuccessful"] = "Page removed from saved";
    NotificationMessage["ErrorOnSave"] = "There was a problem saving the page. Please try again.";
    NotificationMessage["ErrorOnUnsave"] = "There was a problem removing the page from saved. Please try again.";
})(NotificationMessage || (NotificationMessage = {}));
var PageSavedStatusNotification = function (_a) {
    var isShowing = _a.isShowing, onClose = _a.onClose, type = _a.type, message = _a.message, showAction = _a.showAction;
    var springboardBaseUrl = (0, inversify_react_1.useInjection)("springboardAppBaseUrl");
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 1 }, function () { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("notification"), "qwilr-font") },
        react_1.default.createElement(kaleidoscope_3.Notification, { isShowing: isShowing, onClose: onClose, type: type },
            react_1.default.createElement("div", { className: c("notification-body") },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, message)),
            showAction && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, href: function () { return "".concat(springboardBaseUrl, "/saved?origin=saved%20page%20notification"); } }, "Saved pages"))))); }));
};
var SpringboardEngagementMenu = function (props) {
    var _a;
    var projectSecret = (0, inversify_react_1.useInjection)("projectSecret");
    var consumerDataServiceBaseUrl = (0, inversify_react_1.useInjection)("consumerDataServiceBaseUrl");
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    var _b = (0, clerk_react_1.useAuth)(), isSignedIn = _b.isSignedIn, getToken = _b.getToken, isLoaded = _b.isLoaded;
    var user = (0, clerk_react_1.useUser)().user;
    var loadingUser = !isLoaded;
    var _c = __read((0, react_1.useState)(true), 2), loadingSavedState = _c[0], setLoadingSavedState = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), showVerifyIdentityPrompt = _d[0], setShowVerifyIdentityPrompt = _d[1];
    var _e = __read((0, react_1.useState)(""), 2), notificationMessage = _e[0], setNotificationMessage = _e[1];
    var _f = __read((0, react_1.useState)(""), 2), errorMessage = _f[0], setErrorMessage = _f[1];
    var popoverRef = (0, react_1.useRef)(null);
    var isInline = (_a = props.isInline) !== null && _a !== void 0 ? _a : false;
    var showInlineSaveButton = isInline || isMobile();
    var _g = __read((0, react_1.useState)(false), 2), saved = _g[0], setSaved = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), pending = _h[0], setPending = _h[1];
    var savePage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, (0, pageSavedStatus_1.setSavedPage)(consumerDataServiceBaseUrl, projectSecret, getToken)];
                case 2:
                    _a.sent();
                    setSaved(true);
                    setPending(false);
                    track("Saved Qwilr Page");
                    setNotificationMessage(NotificationMessage.SaveSuccessful);
                    setTimeout(function () { return setNotificationMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    setPending(false);
                    setErrorMessage(NotificationMessage.ErrorOnSave);
                    setTimeout(function () { return setErrorMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var deletePage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, (0, pageSavedStatus_1.deleteSavedPage)(consumerDataServiceBaseUrl, projectSecret, getToken)];
                case 2:
                    _a.sent();
                    setSaved(false);
                    setPending(false);
                    track("Unsaved Qwilr Page", { event_origin: "springboard engagement menu" });
                    setNotificationMessage(NotificationMessage.UnsaveSuccessful);
                    setTimeout(function () { return setNotificationMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 3:
                    error_2 = _a.sent();
                    setPending(false);
                    setErrorMessage(NotificationMessage.ErrorOnUnsave);
                    setTimeout(function () { return setErrorMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var onShowUnsavePrompt = function () {
        setNotificationMessage("");
        setErrorMessage("");
    };
    (0, react_1.useEffect)(function () {
        if (isLoaded) {
            (0, pageSavedStatus_1.fetchPageSavedState)(consumerDataServiceBaseUrl, projectSecret, getToken).then(function (isSaved) {
                setLoadingSavedState(false);
                setSaved(isSaved);
                var shouldSavePage = localStorage.getItem(STORAGE_KEY);
                if (shouldSavePage) {
                    if (!isSaved && isSignedIn) {
                        savePage();
                    }
                    localStorage.removeItem(STORAGE_KEY);
                }
            });
        }
    }, [isLoaded]);
    var handlePopoverEnter = function (node) {
        setTimeout(function () {
            if (!popoverRef.current)
                return;
            popoverRef.current.style.width = "".concat(node.offsetWidth, "px");
            popoverRef.current.style.height = "".concat(node.offsetHeight, "px");
            return popoverRef.current.offsetHeight;
        });
    };
    var handlePopoverEntered = function (node) {
        setTimeout(function () {
            if (!popoverRef.current)
                return;
            popoverRef.current.style.width = "auto";
            popoverRef.current.style.height = "auto";
        }, 100);
    };
    var handlePopoverExit = function (node) {
        if (!popoverRef.current)
            return;
        popoverRef.current.style.width = "".concat(node.offsetWidth, "px");
        popoverRef.current.style.height = "".concat(node.offsetHeight, "px");
        return popoverRef.current.offsetHeight;
    };
    var popoverSize = function () {
        if (showVerifyIdentityPrompt) {
            return "large";
        }
        if (isSignedIn) {
            return "medium";
        }
        return "small";
    };
    return (react_1.default.createElement(MaybeWithPanel, { isInline: isInline },
        showInlineSaveButton ? (react_1.default.createElement(WithLoadingState, { loading: loadingSavedState, className: c("ghost-icon-button") }, isSignedIn ? (react_1.default.createElement(InlineSaveButton, { pending: pending, saved: saved, handleSave: savePage, handleDelete: deletePage, handleShowUnsavePrompt: onShowUnsavePrompt })) : (react_1.default.createElement(SaveButtonWithSpringboardAccountPopover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ className: c("inline-save-button"), type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.Bookmark, null) }, buttonProps))); } })))) : (react_1.default.createElement(WithLoadingState, { loading: loadingSavedState, className: c("ghost-icon-button") }, isSignedIn ? (react_1.default.createElement(SaveButton, { pending: pending, saved: saved, handleSave: savePage, handleDelete: deletePage, handleShowUnsavePrompt: onShowUnsavePrompt })) : (react_1.default.createElement(SaveButtonWithSpringboardAccountPopover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, className: c("save-button") }, buttonProps),
                react_1.default.createElement(icons_1.Bookmark, null),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: c("button-text-override") }, "Save"))); } })))),
        react_1.default.createElement(PageSavedStatusNotification, { isShowing: !!notificationMessage, onClose: function () { return setNotificationMessage(""); }, type: kaleidoscope_3.NotificationType.Success, message: notificationMessage, showAction: notificationMessage === NotificationMessage.SaveSuccessful }),
        react_1.default.createElement(PageSavedStatusNotification, { isShowing: !!errorMessage, onClose: function () { return setErrorMessage(""); }, type: kaleidoscope_3.NotificationType.Error, message: errorMessage }),
        !isInline && react_1.default.createElement("div", { className: c("divider") }),
        react_1.default.createElement(WithLoadingState, { loading: loadingUser, className: c("ghost-icon-button") },
            react_1.default.createElement(kaleidoscope_1.Popover, { offset: isInline ? 16 : 8, className: c("popover"), size: kaleidoscope_1.PopoverSize.Auto, recalculatePositionOnResize: true, button: function (buttonProps) {
                    var _a, _b;
                    return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { "aria-label": isSignedIn ? "Springboard options" : "Page options", isRound: isSignedIn, icon: isSignedIn && !!user ? (react_1.default.createElement(UserAvatar_1.UserAvatar, { size: "small", url: user.profileImageUrl, name: user.fullName ? user.fullName : (_b = (_a = user.primaryEmailAddress) === null || _a === void 0 ? void 0 : _a.emailAddress) !== null && _b !== void 0 ? _b : "" })) : (react_1.default.createElement(icons_1.OptionsVertical, null)) })));
                }, onChange: function (isOpen) {
                    if (isOpen) {
                        setShowVerifyIdentityPrompt(false);
                    }
                } },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("popover-inner"), c("popover-inner", popoverSize())), ref: popoverRef },
                    react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null }, showVerifyIdentityPrompt ? (react_1.default.createElement(react_transition_group_1.Transition, { key: "springboard-account-prompt", timeout: kaleidoscope_1.AnimationDuration.Medium, onExit: handlePopoverExit, onEnter: handlePopoverEnter, onEntered: handlePopoverEntered }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("popover-panel"), c("popover-panel", "large"), c("popover-panel", status)) },
                        react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("popover-panel-back"), icon: react_1.default.createElement(icons_1.ChevronLeft, null), onClick: function () { return setShowVerifyIdentityPrompt(false); } }),
                        react_1.default.createElement(SpringboardAccountPrompt, { action: "contact owner", continueUrl: window.location.href }))); })) : (react_1.default.createElement(react_transition_group_1.Transition, { key: "menu", timeout: kaleidoscope_1.AnimationDuration.Medium, onExit: handlePopoverExit, onEnter: handlePopoverEnter, onEntered: handlePopoverEntered }, function (status) {
                        var _a, _b, _c;
                        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("popover-panel"), c("popover-panel", popoverSize()), c("popover-panel", status)) },
                            isSignedIn && !!user && (react_1.default.createElement("div", { className: c("user") },
                                react_1.default.createElement(UserAvatar_1.UserAvatar, { size: "large", url: user.profileImageUrl, name: user.fullName ? user.fullName : (_b = (_a = user.primaryEmailAddress) === null || _a === void 0 ? void 0 : _a.emailAddress) !== null && _b !== void 0 ? _b : "" }),
                                react_1.default.createElement("div", { className: c("user-details") },
                                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" }, user.fullName),
                                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", lineHeight: "compact" }, (_c = user.primaryEmailAddress) === null || _c === void 0 ? void 0 : _c.emailAddress)))),
                            react_1.default.createElement("div", { className: c("menu") }, isSignedIn ? (react_1.default.createElement(LoggedInMenu, { mailto: props.mailto })) : (react_1.default.createElement(LoggedOutMenu, { contactOwnerEnabled: !!props.mailto, onClickContactPageOwner: function () {
                                    setShowVerifyIdentityPrompt(true);
                                } })))));
                    }))))))));
};
var MaybeSpringboardEngagementMenu = function (_a) {
    var children = _a.children;
    var sessionKey = "clerkUserWasActive";
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var _b = (0, inversify_react_1.useInjection)("projectSpringboardSettings").engagementMenuEnabled, engagementMenuEnabled = _b === void 0 ? true : _b;
    var isSignedIn = (0, clerk_react_1.useAuth)().isSignedIn;
    (0, react_1.useEffect)(function () {
        if (isSignedIn) {
            try {
                window.sessionStorage.setItem(sessionKey, "true");
            }
            catch (error) {
                console.log("Error when persisting clerkUserWasActive", error);
            }
        }
    }, [isSignedIn]);
    if (isSignedIn) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if (window.sessionStorage.getItem(sessionKey)) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    var menuEnabledForPage = engagementMenuEnabled && !usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu);
    if (menuEnabledForPage) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return null;
};
var WrappedSpringboardEngagementMenu = function (props) {
    var _a;
    var springboardSettings = (0, inversify_react_1.useInjection)("projectSpringboardSettings");
    var contactOwnerEnabled = (_a = springboardSettings.contactPageOwnerEnabled) !== null && _a !== void 0 ? _a : true;
    var ownerEmail = (0, inversify_react_1.useInjection)("projectOwnerUserEmail");
    var authProviderProps = (0, AuthenticationProvider_1.useInjectedAuthProviderProps)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AuthenticationProvider_1.default, __assign({}, authProviderProps),
            react_1.default.createElement(MaybeSpringboardEngagementMenu, null,
                react_1.default.createElement(SpringboardEngagementMenu, { isInline: props.isInline, mailto: contactOwnerEnabled ? ownerEmail : undefined })))));
};
var mountSpringboardEngagementMenu = function (mountReactComponent, props) {
    return mountReactComponent(react_1.default.createElement(WrappedSpringboardEngagementMenu, __assign({}, props)));
};
exports.mountSpringboardEngagementMenu = mountSpringboardEngagementMenu;
